import { gql } from '@apollo/client';

// Location mutations
export const LOCATION_CREATE = gql`
    mutation LocationCreate($input: LocationInput!) {
        locationCreate(input: $input) {
            location {
                id
                name
                description
                address
                sortOrder
                isActive
            }
        }
    }
`;

export const LOCATION_UPDATE = gql`
    mutation LocationUpdate($id: ID!, $input: LocationInput!) {
        locationUpdate(id: $id, input: $input) {
            location {
                id
                name
                description
                address
                sortOrder
                isActive
            }
        }
    }
`;

export const LOCATION_DELETE = gql`
    mutation LocationDelete($id: ID!) {
        locationDelete(id: $id) {
            success
        }
    }
`;

// Entity type mutations
export const ENTITY_TYPE_CREATE = gql`
    mutation EntityTypeCreate($input: EntityTypeInput!) {
        entityTypeCreate(input: $input) {
            entityType {
                id
                name
                slug
                description
                isActive
            }
        }
    }
`;

export const ENTITY_TYPE_UPDATE = gql`
    mutation EntityTypeUpdate($id: ID!, $input: EntityTypeInput!) {
        entityTypeUpdate(id: $id, input: $input) {
            entityType {
                id
                name
                slug
                description
                isActive
            }
        }
    }
`;

// Entity mutations
export const ENTITY_CREATE = gql`
    mutation EntityCreate($input: EntityInput!) {
        entityCreate(input: $input) {
            entity {
                id
                name
                description
                capacity
                isActive
            }
        }
    }
`;

export const ENTITY_UPDATE = gql`
    mutation EntityUpdate($id: ID!, $input: EntityInput!) {
        entityUpdate(id: $id, input: $input) {
            entity {
                id
                name
                description
                capacity
                isActive
            }
        }
    }
`;

export const ENTITY_DELETE = gql`
    mutation EntityDelete($id: ID!) {
        entityDelete(id: $id) {
            success
        }
    }
`;

// Availability mutations
export const ENTITY_AVAILABILITY_SET = gql`
    mutation EntityAvailabilitySet($entityId: ID!, $slots: [AvailabilityInput!]!) {
        entityAvailabilitySet(entityId: $entityId, slots: $slots) {
            entity {
                id
                availabilitySlots {
                    id
                    dayOfWeek
                    startTime
                    endTime
                }
            }
        }
    }
`;

// Blockout mutations
export const BLOCKOUT_CREATE = gql`
    mutation BlockoutCreate($entityId: ID!, $startDatetime: DateTime!, $endDatetime: DateTime!, $reason: String) {
        blockoutCreate(entityId: $entityId, startDatetime: $startDatetime, endDatetime: $endDatetime, reason: $reason) {
            blockout {
                id
                startDatetime
                endDatetime
                reason
            }
        }
    }
`;

export const BLOCKOUT_DELETE = gql`
    mutation BlockoutDelete($id: ID!) {
        blockoutDelete(id: $id) {
            success
        }
    }
`;

// Reservation mutations
export const ADMIN_RESERVATION_CREATE = gql`
    mutation AdminReservationCreate($input: AdminReservationInput!) {
        adminReservationCreate(input: $input) {
            reservation {
                id
                uuid
                startDatetime
                endDatetime
                status
                customerName
            }
        }
    }
`;

export const RESERVATION_CANCEL = gql`
    mutation ReservationCancel($id: ID!, $reason: String) {
        reservationCancel(id: $id, reason: $reason) {
            reservation {
                id
                status
                cancelledAt
            }
        }
    }
`;

export const RESERVATION_UPDATE_STATUS = gql`
    mutation ReservationUpdateStatus($id: ID!, $status: String!) {
        reservationUpdateStatus(id: $id, status: $status) {
            reservation {
                id
                status
            }
        }
    }
`;

export const RESERVATION_UPDATE = gql`
    mutation ReservationUpdate($id: ID!, $notes: String, $internalNotes: String, $partySize: Int) {
        reservationUpdate(id: $id, notes: $notes, internalNotes: $internalNotes, partySize: $partySize) {
            reservation {
                id
                notes
                internalNotes
                partySize
            }
        }
    }
`;
